import React from 'react';
import {
  PagedCollectionProvider,
  submitResource,
  usePagedCollectionState,
  usePagedCollectionDispatch,
} from 'Context/PagedCollectionContext';

const StateContext = React.createContext(undefined);
const DispatchContext = React.createContext(undefined);

const ListContextProvider = (props) => {
  const { linkUrl, ...rest } = props;

  return (
    <PagedCollectionProvider
      StateContext={StateContext}
      DispatchContext={DispatchContext}
      initialState={{
        collectionSelfLink: linkUrl,
      }}
      {...rest}
    />
  );
};

const useListContextDispatch = () => {
  const context = usePagedCollectionDispatch(DispatchContext);

  if (!context) throw new Error('useListContextDispatch must be called from DispatchContext.Provider');

  return context;
};

const useListContextState = () => {
  const context = usePagedCollectionState(StateContext);

  if (!context) throw new Error('useListContextState must be called from StateContext.Provider');

  return context;
};

const useListContext = () => {
  const dispatch = usePagedCollectionState(DispatchContext);
  const state = usePagedCollectionState(StateContext);

  if (!dispatch) {
    throw new Error('useListContext must be called from DispatchContext.Provider');
  }

  if (!state) {
    throw new Error('useListContext must be called from StateContext.Provider');
  }

  return { dispatch, state };
};

export {
  ListContextProvider,
  submitResource,
  useListContext,
  useListContextDispatch,
  useListContextState,
};
